import { createFileRoute } from '@tanstack/react-router';

import { ServiceAuthLayout } from '~/features/service-auth/components/service-auth-layout';

export const Route = createFileRoute('/_authenticated/_tenant/platform/service-auth')({
  component: () => <ServiceAuthLayout />,
});
